import _styled, { default as _styled2, default as _styled3 } from "styled-components";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import * as styles from "./Checkbox.styles";
import { IconCheckmark } from "../../../foundations/Iconography/IconCheckmark";
export var Checkbox = function Checkbox(props) {
  var checkmarkStyles = [styles.checkmark, props.checked && styles.checkmarkChecked];
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: styles.container
  }, /*#__PURE__*/React.createElement(_StyledInput, _extends({}, props, {
    type: "checkbox",
    $_css2: styles.input
  })), /*#__PURE__*/React.createElement(_StyledIconCheckmark, {
    color: 'var(--neutral-white-base)',
    $_css3: checkmarkStyles
  }));
};
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledInput = _styled2("input")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledIconCheckmark = /*#__PURE__*/_styled3(IconCheckmark).withConfig({
  displayName: "Checkbox___StyledIconCheckmark",
  componentId: "sc-4qc43y-0"
})(["", ""], function (p) {
  return p.$_css3;
});